import React from 'react';

import SliderWithThumbnails, {
  ISliderWithThumbnailsProps,
} from 'components/SliderWithThumbnails/SliderWithThumbnails';
import { IDonationOptionGallery } from 'models/donationOptionGallery';

interface DonationOptionGalleryProps
  extends Omit<ISliderWithThumbnailsProps, 'images'> {
  donationOptionGalleries: IDonationOptionGallery[];
  sliderClassname?: string;
}
const DonationOptionGallery: React.FC<DonationOptionGalleryProps> = ({
  donationOptionGalleries,
  sliderClassname,
  ...props
}) => {
  return (
    <SliderWithThumbnails
      {...props}
      images={donationOptionGalleries.map(({ alt, media }) => ({
        alt: alt || media.name,
        src: media.url,
      }))}
      sliderClassname={sliderClassname}
    />
  );
};

export default DonationOptionGallery;
